import { createFileRoute } from "@tanstack/react-router";

import { AdminCanvas } from "@/features/admin";

/**
 * Admin Canvas — wire path ``/admin/canvas``.
 *
 * v1 reference: ``app/admin-v2/components/pages/CanvasPage.tsx`` (126 LoC).
 * BE: ``GET /admin/v2/canvas`` (``admin_v2.py:571``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/canvas")({
  component: AdminCanvas,
});
